export interface PutStreamingSettingsResult {
  /** HTTP and envelope both succeeded. */
  ok: boolean;
  /** The parsed `{ ok, data | message }` envelope. */
  body: { ok?: boolean; data?: unknown; message?: string; [key: string]: unknown };
}

export interface PutStreamingSettingsOptions {
  csrfToken: string | null;
  /** Runs after a successful save, before the result is returned. */
  afterSave: () => void;
}

/**
 * Saves the streaming (WSD) settings. A saved media server connection changes
 * what `hasMediaServer` reports, so the caller's `afterSave` drops the cached
 * app status and every mounted `useSystemApps` refetches, instead of the nav
 * entries that need a server appearing only after the client cache expires.
 */
export const putStreamingSettings = async (
  update: object,
  { csrfToken, afterSave }: PutStreamingSettingsOptions,
): Promise<PutStreamingSettingsResult> => {
  const res = await fetch("/api/streaming/settings", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(csrfToken ? { "x-csrf-token": csrfToken } : {}),
    },
    body: JSON.stringify(update),
  });
  const body = await res.json();
  const ok = res.ok && body?.ok === true;
  if (ok) afterSave();
  return { ok, body };
};
